import React from "react";
import { Button } from "@networkraildigitalfactory/components";
import styles from "./CreateReviewPrep.module.css";

const ButtonRow = (props) => {
  const { isEditing, isDraft, onSave, onEdit, onSubmit } = props;
  const showSaveDraft = !isEditing || isDraft;
  return (
    <div className={styles.button_row}>
      {showSaveDraft ? (
        <Button name="Save as draft" text="Save as draft" onClick={onSave} color="blue" />
      ) : (
        <div />
      )}
      <Button
        name={`${showSaveDraft ? "Submit" : "Re-submit"} prep`}
        text={`${showSaveDraft ? "Submit" : "Re-submit"} prep`}
        onClick={isEditing ? onEdit : onSubmit}
        color="green"
      />
    </div>
  );
};

export default ButtonRow;
